import { ProductRecipe } from '../item/product-recipe';
import { Note, StatusHistoryEntry } from '../shared/common-entities';

// Matches Sierra.Global.Models.Entities.Keys.CodedDocumentKey — all string fields, all optional.
// (Distinct from the unrelated knitting/roll CodedDocumentKey which uses numeric code.)
export interface CodedDocumentKey {
  reference?: string;
  code?: string;
  name?: string;
}

export interface ProductionWorkOrder {
  id: string;
  number: string;
  status: ProductionWorkOrderStatus;
  plantCode: string;
  items: ProductionWorkOrderItem[];
  notes?: Note[];
  estimatedStartDate?: string;
  estimatedEndDate?: string;
  statusHistory?: StatusHistoryEntry<ProductionWorkOrderStatus>[];
}

export interface ProductionWorkOrderItem {
  id: string;
  productRecipeNumber: string;
  productRecipe?: ProductRecipe;
  uom: number;
  quantity: number;
  reservations: ProductionWorkOrderReservation[];
}

export interface ProductionWorkOrderReservation {
  clientPurchaseOrderReference: string;
  clientPurchaseOrderNumber: string;
  clientPurchaseOrderItemId: string;
  clientPurchaseOrderProductRecipeNumber: string;
  reservedQuantity: number;
  client?: CodedDocumentKey;
}

export interface ProductionWorkOrderSearchCommand {
  number?: string;
  plantCode?: string;
  status?: ProductionWorkOrderStatus[];
  itemCodes?: string[];
}

export enum ProductionWorkOrderStatus {
  Draft = 0,
  Approved = 1,
  InProduction = 2,
  Completed = 3,
  Cancelled = 98,
  Deleted = 99,
}

export interface EntityKeyByReference {
  reference: string;
  entityDefinitionCode: number;
}

export interface ProductionWorkOrderInsert {
  status: ProductionWorkOrderStatus;
  items: ProductionWorkOrderItemInsert[];
  notes?: Note[];
  estimatedStartDate?: string;
  estimatedEndDate?: string;
}

export interface ProductionWorkOrderItemInsert {
  productRecipeNumber: string;
  uom: number;
  quantity: number;
  reservations: ProductionWorkOrderReservationInsert[];
}

export interface ProductionWorkOrderReservationInsert {
  clientPurchaseOrderReference: string;
  clientPurchaseOrderNumber: string;
  clientPurchaseOrderItemId: string;
  clientPurchaseOrderProductRecipeNumber: string;
  reservedQuantity: number;
}
